<template>
  <div class="seomain">
    <ul class="tab-tilte four">
      <li
        v-for="(title, index) in tabTitle"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
    <!-- 搜索  单行 -->
    <!-- <div class="keyword">
      <van-search
        v-model="order_code"
        shape="round"
        show-action
        background="#e0e0e0"
        placeholder="请输入订单号搜索"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div> -->

    <!-- 搜索 多行 -->
    <div class="keyword">
      <van-form @submit="submitKeyword">
        <van-field v-model="order_code" label="单号" placeholder="请输入单号" />
        <van-field v-model="sku" label="SKU" placeholder="SKU" />
        <div :style="{ padding: '16px', backgroundColor: '#fff' }">
          <van-button round block type="info" native-type="submit">搜 索</van-button>
        </div>
      </van-form>
    </div>
    <div class="tab-content tab-content-list">
      <div v-show="cur == 0" class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist0" :key="k" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">待拆工</div>
            </div>
            <div class="st-list-main">
              <!-- <p>SKU：{{ v.sku }}</p> -->
              <!-- <p>库存编码：{{ v.inventorycode }}</p> -->
              <!-- <p>商品名称：{{ v.productname }}</p> -->
              <!-- <p>拆解数量：{{ v.quantity }}</p> -->
              <p>经办人：{{ v.operator }}</p>
              <p>下架工单号：{{ v.scrapped_order_code }}</p>
              <p>创建时间：{{ v.createtime | formatDate }}</p>
              <p>拆解状态：待领料</p>
            </div>
            <div class="st-list-bottom">
              <router-link :to="'/disassembly/info/' + v.id" class="st-opt-btn">查 看</router-link>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 1" class="st-list-box pan-1">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist1" :key="k" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">拆解中</div>
            </div>
            <div class="st-list-main">
              <!-- <p>SKU：{{ v.sku }}</p>
              <p>库存编码：{{ v.inventorycode }}</p>
              <p>商品名称：{{ v.productname }}</p>
              <p>待领料：{{ v.to_receive }}</p>
              <p>拆解中：{{ v.disassembling }}</p> -->
              <p>经办人：{{ v.operator }}</p>
              <p>下架工单号：{{ v.scrapped_order_code }}</p>
              <p>创建时间：{{ v.createtime | formatDate }}</p>
            </div>
            <div class="st-list-bottom">
              <router-link :to="'/disassembly/info/' + v.id" class="st-opt-btn">查 看</router-link>
            </div>
            <!-- <div class="st-list-bottom-diy">
              <div class="st-diyl-btn">
                <router-link :to="'/disassembly/info/' + v.id" class="st-opt-btn">申请领料</router-link>
              </div>
              <div class="st-diyr-btn">
                <router-link :to="'/disassembly/main/' + v.id" class="st-opt-btn">拆 卸</router-link>
              </div>
            </div> -->
          </div>
        </van-list>
      </div>
      <div v-show="cur == 2" class="st-list-box pan-3">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist2" :key="k" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">已完成</div>
            </div>
            <div class="st-list-main">
              <!-- <p>SKU：{{ v.sku }}</p>
              <p>库存编码：{{ v.inventorycode }}</p>
              <p>商品名称：{{ v.productname }}</p>
              <p>完成时间：{{ v.fulfiltime }}</p>
              <p>已完成：{{ v.actual_number }}</p>
              <p>待入库：{{ v.total_remainder }}</p> -->
              <p>经办人：{{ v.operator }}</p>
              <p>下架工单号：{{ v.scrapped_order_code }}</p>
              <p>创建时间：{{ v.createtime | formatDate }}</p>
            </div>
            <div class="st-list-bottom">
              <router-link :to="'/disassembly/info/' + v.id + '/false'" class="st-opt-btn">查 看</router-link>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 3" class="st-list-box pan-2">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist3" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">已入库</div>
            </div>
            <div class="st-list-main">
              <!-- <p>SKU：{{ v.sku }}</p>
              <p>库存编码：{{ v.inventorycode }}</p>
              <p>商品名称：{{ v.productname }}</p>
              <p>完成时间：{{ v.fulfiltime }}</p>
              <p>已完成：{{ v.actual_number }}</p>
              <p>已入库：{{ v.total_warehousing }}</p>
              <p>异常数量：{{ v.total_loss }}</p> -->
              <p>经办人：{{ v.operator }}</p>
              <p>下架工单号：{{ v.scrapped_order_code }}</p>
              <p>创建时间：{{ v.createtime | formatDate }}</p>
            </div>
            <div class="st-list-bottom">
              <router-link :to="'/disassembly/info/' + v.id + '/false'" class="st-opt-btn">查 看</router-link>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,

      tabTitle: ["待拆工", "拆解中", "已完成", "已入库"],
      cur: 0,
      stlist0: [],
      stlist1: [],
      stlist2: [],
      stlist3: [],
      order_code: "", // 关键字搜索
      sku: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    async get_st_list(e) {
      this.stlist0 = [];
      this.stlist1 = [];
      this.stlist2 = [];
      this.stlist3 = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      let activeIndex = window.sessionStorage.getItem("disassembly_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
      }
    },
    changeActiveIndex(value) {
      this.cur = value;
      window.sessionStorage.setItem("disassembly_activeIndex", value);
    }, // 分页
    async onLoad() {
      let result = await this.$post(this.$api.stGetChaigongList, {
        order_code: this.order_code,
        status: this.cur,
        page: this.page,
        sku: this.sku,
      });

      if (result.data.length == 0) return (this.finished = true);
      // 进行操作
      this["stlist" + this.cur].push(...result.data.list);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },
    onSearch(val) {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
    // 关键字搜索
    submitKeyword() {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
  },
  created() {
    this.init();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "拆工" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.keyword {
  position: fixed;
  width: 100%;
  top: 50px;
}
/* 2行input start */
.tab-content-list {
  padding-top: 220px;
}
/* 2行input  end */

.four li {
  width: 25%;
}
.pan-1 .t-tit {
  border-left: 3px solid #3c8dbc;
}
.pan-1 .t-status {
  color: #3c8dbc;
}
.pan-1 .st-list-bottom {
  background: #3c8dbc;
}
</style>
